<script>
export default {
  name: 'PaymentError',
};
</script>

<template>
  <div style="text-align: center" :v-show="path">We could not take payment at this time...</div>
</template>
